// Goals API — list / create per client, plus update / delete by goal id.
// Goals are children of a client (goal->client->trainer ownership on the
// backend); list/create are client-scoped, update/delete are by goal id.
import { http } from "./http";
import type { Goal, GoalInput, OkResponse } from "./types";

export const goalsApi = {
  list: (clientId: number, activeOnly = true, signal?: AbortSignal) =>
    http.get<Goal[]>(
      `/clients/${clientId}/goals`,
      { active_only: activeOnly },
      signal,
    ),
  create: (clientId: number, body: GoalInput) =>
    http.post<Goal>(`/clients/${clientId}/goals`, body),
  update: (goalId: number, body: GoalInput) =>
    http.patch<Goal>(`/goals/${goalId}`, body),
  remove: (goalId: number) => http.del<OkResponse>(`/goals/${goalId}`),
};
